import {
  FETCH_CARDS_SUCCESS,
  FETCH_CARDS_ERROR,
  DELETE_CARD,
  FETCH_CARDS_NEXT_PAGE,
  FETCH_CARDS_FINISH_LOADING,
  FETCH_CARDS_START_LOADING,
  DELETE_CARD_HIELOCO,
  ADD_CARD_HIELOCO,
} from '../types/cards';

let initialState = {
  loading: false,
  error: null,
  items: [],
  currentPage: 0,
  totalPages: 0,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  // Global variables
  let cardIndex;

  switch (type) {
    case FETCH_CARDS_START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CARDS_FINISH_LOADING:
      return {
        ...state,
        loading: false,
      };
    case FETCH_CARDS_SUCCESS:
      return {
        ...state,
        ...payload,
        items: [...payload.items],
      };
    case FETCH_CARDS_NEXT_PAGE:
      return {
        ...state,
        ...payload,

        items: [...state.items, ...payload.items],
      };
    case FETCH_CARDS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };
    case DELETE_CARD:
      const { id } = payload;
      const { items } = state;

      const index = items.findIndex((card) => card.id === id);
      items.splice(index, 1);

      return {
        ...state,
        items: [...items],
      };

    case ADD_CARD_HIELOCO:
      cardIndex = state.items.findIndex((card) => card.id === payload.card_id);

      state.items[cardIndex].Card_Hielocos.push(payload.cardHieloco);

      return {
        ...state,
        items: [...state.items],
      };
    case DELETE_CARD_HIELOCO:
      cardIndex = state.items.findIndex((card) => card.id === payload.card_id);

      const hielocoIndex = state.items[cardIndex].Card_Hielocos.findIndex(
        (cardHieloco) => cardHieloco.hieloco_id === payload.hieloco_id
      );

      state.items[cardIndex].Card_Hielocos.splice(hielocoIndex, 1);

      return {
        ...state,
        items: [...state.items],
      };

    default:
      return state;
  }
}
